import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'networkGuardianAccessMe',
})
export class NetworkGuardianAccessMe implements PipeTransform {
  transform(parent_id: number, items: any[]): any {
    if (items?.length) {
      let findIndex = items?.findIndex((x) => x.user_id == parent_id);
      return findIndex == -1 ? false : true;
    } else {
      return false;
    }
  }
}
